import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceNames } from '../interfaces/my7n-env-config';
import { lastValueFrom } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { IFeedbackModalAdditionalData } from '../interfaces/feedback-modal';

@Injectable()
export class FeedbackService {

  constructor(private http: HttpClient,
              private appConfigService: AppConfigService) { }

  sendEmail(feedbackType: string, feedbackContent: string, additionalData: IFeedbackModalAdditionalData): Promise<string> {
    return lastValueFrom(this.http.put(
      this.appConfigService.serviceUrl(ServiceNames.User, 'v1') + 'user/feedback',
      {
        FeedbackType: feedbackType,
        FeedbackContent: feedbackContent,
        Data: additionalData
      },
      { responseType: 'text' }
    ));
  }
}
